import React from 'react';
import { Text, withSitecoreContext, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { CardGroupGrid as CardGroupGridNPM } from '@rotaryintl/component-landing-pages';

const CardGroupGrid = ({ rendering, params: { ComponentId } = {}, fields: { Title } = {} }) => (
  <CardGroupGridNPM id={ComponentId} title={<Text field={Title} />} cardsPlaceholder={<Placeholder name="cardgroupgrid-cards" rendering={rendering} />} />
);

export default withSitecoreContext()(CardGroupGrid);
